import { render, staticRenderFns } from "./direct-app-debug.vue?vue&type=template&id=7befd604"
import script from "./direct-app-debug.vue?vue&type=script&lang=js"
export * from "./direct-app-debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports